import type { FC } from 'react';

export type EntryType = 'linkedin' | 'email' | 'thread' | 'blog';
export type EntryStatus = 'draft' | 'scheduled' | 'published';

export interface CalendarEntryData {
  id: string;
  title: string;
  type: EntryType;
  status: EntryStatus;
  scheduledDate: string;
  persona?: string;
  description?: string;
}

const TYPE_COLORS: Record<EntryType, { bg: string; text: string; border: string }> = {
  linkedin: {
    bg: 'bg-blue-50 dark:bg-blue-900/20',
    text: 'text-blue-700 dark:text-blue-300',
    border: 'border-l-2 border-blue-500',
  },
  email: {
    bg: 'bg-emerald-50 dark:bg-emerald-900/20',
    text: 'text-emerald-700 dark:text-emerald-300',
    border: 'border-l-2 border-emerald-500',
  },
  thread: {
    bg: 'bg-violet-50 dark:bg-violet-900/20',
    text: 'text-violet-700 dark:text-violet-300',
    border: 'border-l-2 border-violet-500',
  },
  blog: {
    bg: 'bg-orange-50 dark:bg-orange-900/20',
    text: 'text-orange-700 dark:text-orange-300',
    border: 'border-l-2 border-orange-500',
  },
};

const STATUS_DOT: Record<EntryStatus, string> = {
  draft: 'bg-slate-400',
  scheduled: 'bg-blue-500',
  published: 'bg-emerald-500',
};

interface CalendarEntryProps {
  entry: CalendarEntryData;
  onClick: (entry: CalendarEntryData) => void;
}

const CalendarEntry: FC<CalendarEntryProps> = ({ entry, onClick }) => {
  const colors = TYPE_COLORS[entry.type];
  const dot = STATUS_DOT[entry.status];

  return (
    <button
      onClick={() => onClick(entry)}
      className={`w-full text-left rounded px-1.5 py-0.5 text-[11px] font-medium truncate
        ${colors.bg} ${colors.text} ${colors.border}
        hover:opacity-80 transition-opacity cursor-pointer`}
    >
      <span className={`inline-block h-1.5 w-1.5 rounded-full mr-1 ${dot}`} />
      {entry.title}
    </button>
  );
};

export default CalendarEntry;
